import React from 'react';
import PropTypes from 'prop-types';
import { MotifButton } from '@ey-xd/motif-react';
import { Field, reduxForm } from 'redux-form';
import * as formHelpers from '../../scripts/formHelpers';

const PublishDataHeader = ({
  reportPeriods,
  handlePeriodChange,
  onCancel,
  onSubmit,
  defaultReportPeriod,
  isSelectionChanged,
}) => {
  const periodOptions =
    reportPeriods?.map((period) => ({
      key: period,
      text: period,
      value: period,
    })) || [];
  return (
    <>
      {/* If no data for report period, show message and skip header form */}
      <div className="row mt-5 align-items-start gx-2">
        <div className="col-lg-2 col-md-3 col-sm-6 mb-3">
          <Field
            name="reportPeriod"
            label="Report Period"
            testingData={{ label: 'lblReportPeriod', div: 'divReportPeriod' }}
            data-testid="btnReportPeriod"
            onChange={handlePeriodChange}
            options={periodOptions}
            component={formHelpers.SingleSelectComponent}
            defaultValue={defaultReportPeriod ? defaultReportPeriod : ''}
          />
        </div>
        <div className="col-lg-8 col-md-4 col-sm-6 mb-3" />
        {/* Action Buttons */}
        <div className="col-lg-2 mb-3">
          <div className="d-flex justify-content-lg-end">
            <MotifButton
              className="mr-3"
              variant="secondary"
              onClick={onCancel}
              data-testid="btnCancel"
            >
              Cancel
            </MotifButton>
            <MotifButton
              variant="primary"
              onClick={onSubmit}
              data-testid="btnSubmit"
              disabled={!isSelectionChanged}
            >
              Submit
            </MotifButton>
          </div>
        </div>
      </div>
    </>
  );
};

PublishDataHeader.propTypes = {
  reportPeriods: PropTypes.array.isRequired,
  handlePeriodChange: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  defaultReportPeriod: PropTypes.string,
  isSelectionChanged: PropTypes.bool.isRequired,
};

export default reduxForm({ form: 'PublishDataHeader' })(PublishDataHeader);
